import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../services/redux/hook';
import { toggleCrypto } from '../services/redux/slices/crypto_mode/crypto_mode';

const useCryptoMode = () => {

    const cryptoMode = useAppSelector((state) => state.cryptoMode.enabled);
    const dispatch = useAppDispatch();

    useEffect(() => {
        
    }, [cryptoMode]);

    const toggleModeHandler = () => {
        dispatch(toggleCrypto());
    };

    return { cryptoMode, toggleModeHandler }; 
};

export default useCryptoMode;
